'use client';

import { memo } from 'react';
import { useTranslations } from 'next-intl';
import { GlowButton, GlowTitle } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';
import {
    SearchBrandsSkeleton,
    SearchCategoriesSkeleton,
    SearchResultItemSkeleton,
    SearchSuggestSkeleton,
} from './skeletons';

type SearchSuggestionsSkeletonProps = {
    onSearchHandler: () => void;
};

export const SearchSuggestionsSkeleton: ComponentMemo<SearchSuggestionsSkeletonProps> = memo(({ onSearchHandler }) => {
    const t = useTranslations('Header.search');

    return (
        <>
            <section className={'flex flex-col flex-1 gap-1.5 flex-grow-3'}>
                <GlowTitle text={t('label.products')} fontSize={'title5'} />
                <ul className={'grid grid-cols-1 tablet:grid-cols-2 gap-y-1.5 gap-x-2.5 justify-center items-start'}>
                    {Array.from({ length: 6 }).map((_, index) => (
                        <li className={'w-full'} key={`product-suggestion-${index}`}>
                            <div className={'flex flex-row flex-1 items-center gap-1 py-0.5'}>
                                <SearchResultItemSkeleton />
                            </div>
                        </li>
                    ))}
                </ul>
                <GlowButton className={'w-maxContent'} label={t('action.viewAllProducts')} onClick={onSearchHandler} />
            </section>
            <section className={'flex flex-col gap-1.5 flex-1'}>
                <GlowTitle text={t('label.suggestions')} fontSize={'title5'} />
                <div className={'flex flex-col gap-0.5 w-full'}>
                    <SearchSuggestSkeleton />
                </div>
                <GlowTitle text={t('label.categories')} fontSize={'title5'} />

                <div className={'flex flex-col gap-0.75 w-full'}>
                    <SearchCategoriesSkeleton />
                </div>
                <GlowTitle text={t('label.brands')} fontSize={'title5'} />
                <div className={'flex flex-row gap-0.5 w-full'}>
                    <SearchBrandsSkeleton />
                </div>
            </section>
        </>
    );
});

SearchSuggestionsSkeleton.displayName = 'SearchSuggestionsSkeleton';
